<template>
  <section class="drug-alerts">
    <div class="container">
      <div class="alerts-intro">
        <h1 class="alert-card__title">Drug Alerts</h1>
        <template v-if="alerts.length > 0">
          <p>Last updated {{ formatDate(alerts[0].pubDate) }}</p>
          <p>
            ADF has partnered with The Know to deliver up-to-date and reliable drug alerts. The
            current list updated {{ formatDate(alerts[0].pubDate) }} includes alerts from the past
            four months
          </p>
        </template>
        <a href="https://theknow.org.au/" target="_blank" class="alert-card__the-know">
          See all Drug Alerts on The Know
        </a>
      </div>
      <div class="alerts-grid">
        <div v-for="alert in alerts" :key="alert.guid" class="alert-card">
          <a :href="alert.link" target="_blank" class="alert-card__link">
            <span class="icon icon--link">
              <external-link2-icon />
            </span>
            {{ alert.title }}
          </a>
          <p class="alert-card__date">{{ formatDate(alert.pubDate) }} . {{ alert.location }}</p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import ExternalLink2Icon from '@/components/svg/ExternalLink2Icon.vue';

export default {
  name: 'DrugAlerts',
  components: { ExternalLink2Icon },
  data() {
    return {
      alerts: [],
    };
  },
  async created() {
    await this.fetchAlerts();
  },
  methods: {
    async fetchAlerts() {
      try {
        const response = await axios.get('/api/rss-proxy/');
        this.parseRssFeed(response.data);
      } catch (error) {
        console.error('Error fetching drug alerts:', error);
      }
    },
    parseRssFeed(rssString) {
      const parser = new DOMParser();
      const xmlDoc = parser.parseFromString(rssString, 'text/xml');
      const items = [...xmlDoc.querySelectorAll('item')];

      this.alerts = items.map((item) => {
        return {
          title: item.querySelector('title')?.textContent ?? '',
          link: item.querySelector('link')?.textContent ?? '',
          pubDate: item.querySelector('pubDate')?.textContent ?? '',
          guid: item.querySelector('guid')?.textContent ?? '',
          location:
            item.querySelector('category[domain="location_taxonomy"]')?.textContent ?? 'National',
        };
      });
    },
    formatDate(dateString) {
      if (!dateString) return '';
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
  },
};
</script>
